import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { Input, Select } from "./fields";
import { SOCIAL_OPTIONS, SOCIAL_PLATFORMS } from "@/components/site/SocialIcons";

const uid = () => `soc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 5)}`;

export const AdminSocials = ({ items = [], onChange }) => {
  const set = (i, patch) => { const c = [...items]; c[i] = { ...c[i], ...patch }; onChange(c); };
  const move = (i, dir) => { const j = i + dir; if (j < 0 || j >= items.length) return; const c = [...items]; [c[i], c[j]] = [c[j], c[i]]; onChange(c); };
  const add = () => onChange([...items, { id: uid(), platform: "instagram", url: "" }]);

  return (
    <div className="space-y-3 md:col-span-2 border-t border-white/10 pt-5" data-testid="admin-socials-editor">
      <div className="flex items-center justify-between">
        <span className="text-[11px] tracking-[0.25em] uppercase text-electric">Réseaux sociaux</span>
        <button onClick={add} data-testid="admin-add-social" className="inline-flex items-center gap-2 text-xs text-white/70 hover:text-electric"><Plus size={14} /> Ajouter un réseau</button>
      </div>
      <p className="text-xs text-secondary2">L'icône officielle en couleur s'affiche automatiquement selon le réseau choisi.</p>
      {items.length === 0 && <p className="text-xs text-secondary2">Aucun réseau. Cliquez sur « Ajouter un réseau ».</p>}
      {items.map((s, i) => {
        const p = SOCIAL_PLATFORMS[s.platform] || SOCIAL_PLATFORMS.website;
        const Icon = p.Icon;
        return (
          <div key={s.id || i} data-testid={`admin-social-${i}`} className="flex items-end gap-3 rounded border border-white/10 bg-[#0a0a0a] p-3">
            <span className="w-10 h-10 shrink-0 rounded-full border border-white/15 flex items-center justify-center mb-1"><Icon size={18} color={p.color} /></span>
            <div className="w-44"><Select label="Réseau" value={s.platform} onChange={(v) => set(i, { platform: v })} options={SOCIAL_OPTIONS} /></div>
            <div className="flex-1"><Input label="Lien (URL)" value={s.url} onChange={(v) => set(i, { url: v })} placeholder="https://..." /></div>
            <div className="flex items-center gap-2 mb-2">
              <button onClick={() => move(i, -1)} className="text-white/40 hover:text-electric"><ArrowUp size={14} /></button>
              <button onClick={() => move(i, 1)} className="text-white/40 hover:text-electric"><ArrowDown size={14} /></button>
              <button onClick={() => onChange(items.filter((_, x) => x !== i))} data-testid={`admin-social-delete-${i}`} className="text-red-400/70 hover:text-red-400"><Trash2 size={15} /></button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
